module.exports = __webpack_public_path__ + "static/8-90add9b832f6c2db900288b0e575cb95.png";